import Request from '@/plugins/request';

export function getWithdrawalCfgs(params) {
  return Request.get('withdrawal-cfgs', { params })
}

export function createWithdrawalCfg() {
  return Request.get(`withdrawal-cfgs/create`)
}

export function storeWithdrawalCfg(data) {
  return Request.post('withdrawal-cfgs', data)
}

export function updateWithdrawalCfg(id, data) {
  return Request.put(`withdrawal-cfgs/${id}`, data)
}

export function editWithdrawalCfg(id) {
  return Request.get(`withdrawal-cfgs/${id}/edit`)
}

export function destroyWithdrawalCfg(id) {
  return Request.delete(`withdrawal-cfgs/${id}`)
}
